import { MojaFirmaClient } from '@kodit/core/data-api';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-podesavanje-racuna-page',
  templateUrl: './podesavanje-racuna-page.component.html',
  styleUrls: ['./podesavanje-racuna-page.component.scss']
})
export class PodesavanjeRacunaPageComponent implements OnInit {

  private _subs: Subscription = new Subscription();
  displayPlacanjeStarihRacuna: boolean = false;

  constructor(
    private _client: MojaFirmaClient
  ) { }

  ngOnInit(): void {
    this._subs.add(
      this._client
        .getKonfiguracija()
        .subscribe(
          (res) => {
            this.displayPlacanjeStarihRacuna = res.data.displayPlacanjeStarihRacuna;
          }
        )
    );
  }

}
